import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../pages/Sidebar";
import SecNavbar from "../components/SecNavbar";
import { useDefaultContext } from "../components/context/defaultcontext";

const MainLayout = ({ children }) => {
  const { sidebarToogle } = useDefaultContext();

  return (
    <div className="d-flex" style={{ height: "100vh", overflow: "hidden" }}>
      {/* SIDEBAR - NO SCROLL */}
      <div style={{ flexShrink: 0 }} className="d-none d-lg-block">
        {sidebarToogle ? <Sidebar /> : <SecNavbar />}
      </div>

      {/* RIGHT SIDE */}
      <div className="d-flex flex-column w-100" style={{ overflow: "hidden" }}>
        {/* NAVBAR - NO SCROLL */}
        <div style={{ flexShrink: 0 }}>
          <Navbar />
        </div>

        {/* CONTENT - ONLY THIS SCROLLS */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            // padding: "10px"
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
